window.onpageshow = function (/** Event */ event) {
    if (event['persisted']) {
        window.location.reload();
    }
};

window.onbeforeunload = function () {
	document.body.opacity = 0;
	window.scrollTo(0,0);
};

/**
 * @param {string} QuoteID
 * @param {function(number,string,string,string,string)|undefined} Success
 */
function AddQuoteToCart(QuoteID, Success) {
	Success = typeof Success === 'function' ? Success : $.noop();
	Ajax({
		'url': '/helen/addquotetocart',
		'data': {
			'QuoteID': QuoteID
		},
		'success': function (/** Object<string,?> */ data) {
			Success(
				/** @type {number} */ (data['cartitemscount']),
				/** @type {string} */ (data['cart']),
				/** @type {string} */ (data['carttotal']),
				/** @type {string} */ (data['cartshipping']),
				/** @type {string} */ (data['promocode']),
            );
            gtm(':helen.main.addquotetocart.success');
        },
        'error': function () {
            gtm(':helen.main.addquotetocart.error');
        }
	});
}

/**
 * @param {string} OrderID
 * @param {function(number,string,string,string,string)|undefined} Success
 */
function AddOrderToCart(OrderID, Success) {
	Success = typeof Success === 'function' ? Success : $.noop();
	Ajax({
		'url': '/helen/addordertocart',
		'data': {
			'OrderID': OrderID
		},
		'success': function (/** Object<string,?> */ data) {
			Success(
				/** @type {number} */ (data['cartitemscount']),
				/** @type {string} */ (data['cart']),
				/** @type {string} */ (data['carttotal']),
                /** @type {string} */ (data['cartshipping']),
                /** @type {string} */ (data['promocode']),
            );
            gtm(':helen.main.addordertocart.success');
        },
        'error': function () {
            gtm(':helen.main.addordertocart.error');
        },
	});
}

/**
 * @param {string} QuoteID
 * @param {function(number,string,string,string,string)|undefined} Success
 */
function DeleteQuoteFromCart(QuoteID, Success) {
	Success = typeof Success === 'function' ? Success : $.noop();
	Ajax({
		'url': '/helen/deletequotefromcart',
		'data': {
			'QuoteID': QuoteID
		},
		'success': function (/** Object<string,?> */ data) {
			Success(
				/** @type {number} */ (data['cartitemscount']),
				/** @type {string} */ (data['cart']),
				/** @type {string} */ (data['carttotal']),
                /** @type {string} */ (data['cartshipping']),
                /** @type {string} */ (data['promocode']),
            );
            gtm(':helen.main.deletequotefromcart.success');
        },
        'error': function () {
            gtm(':helen.main.deletequotefromcart.error');
        }
	});
}

/**
 * @param {string} OrderID
 * @param {function(number,string,string,string,string)|undefined} Success
 */
function DeleteOrderFromCart(OrderID, Success) {
	Success = typeof Success === 'function' ? Success : $.noop();
	Ajax({
		'url': '/helen/deleteorderfromcart',
		'data': {
			'OrderID': OrderID
		},
		'success': function (/** Object<string,?> */ data) {
			Success(
				/** @type {number} */ (data['cartitemscount']),
				/** @type {string} */ (data['cart']),
				/** @type {string} */ (data['carttotal']),
                /** @type {string} */ (data['cartshipping']),
                /** @type {string} */ (data['promocode']),
            );
            gtm(':helen.main.deleteorderfromcart.success');
        },
        'error': function () {
            gtm(':helen.main.deleteorderfromcart.error');
        }
	});
}

const delay = 0;
const offset = 150;

document.addEventListener('invalid', function (/** Event */ e) {
   $(e.target).addClass("invalid");
   $('html, body').animate({'scrollTop': $($(".invalid")[0]).offset().top - offset}, delay);
}, true);
document.addEventListener('change', function (/** Event */ e){
   $(e.target).removeClass("invalid");
}, true);

$(document).on('click', 'a[href="/helen/logout"]', function () {
    gtm(':helen.main.logout');
});